import React from "react";

export const DSNhanVayConst = {
  TinhTrangNhanVay: {
    TatCa: 0,
    DangVay: 1,
    DuLai: 5,
    NoLai: 3,
    QuaHan: 4,
    Dong: 2,
  },
};

export const NhanVayCombo = {
  StatusDefault: "- Trạng thái -",
  StatusCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Đang vay" },
    { value: "5", label: "Đủ lãi" },
    { value: "3", label: "Nợ lãi" },
    { value: "4", label: "Quá hạn" },
    { value: "2", label: "Đóng" },
  ],
  TypePaid: { None: -1, Ngay: 1, Thang: 2, ThangDinhKy: 3 },
  TypePaidDropdown: [
    { value: "1", label: "Ngày" },
    { value: "2", label: "Tháng" },
    { value: "3", label: "Tháng Định Kỳ" },
  ],
  KieuLaiSuatDropdown: [
    { value: "0", label: "Lãi/triệu/ngày" },
    { value: "1", label: "Lãi/Ngày" },
    { value: "2", label: "Lãi%/tháng" },
    { value: "3", label: "Lãi kỳ" },
    { value: "4", label: "Lãi % tháng định kỳ" },
  ],
};
